import { locales, recursiveMerge } from '@/plugins/xtpgui';

export default recursiveMerge(locales.esES, {
    'customer.title'                : 'Registro de Proveedor',
    'customer.search'               : 'Localizar',
    'customer.edit'                 : 'Editar',
    'countries.search'              : 'Localizar',
    'countries.edit'                : 'Editar',
    'countries.title'               : 'Registro de País',
    'MovimentosEmAberto.search'      : 'Localizar',
    'MovimentosEmAberto.edit'        : 'Editar',
    'MovimentosEmAberto.title'       : 'Entrada de Transacciones',

    
    $vuetify: {},

    $dataTable: {},
});